import { createQueryKeys } from "@lukemorales/query-key-factory";
import {
  queryOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";

import { usePaginateQuery } from "@/hooks";
import { api } from "@/lib/api";
import { type Paginate, type SearchRequest } from "@/types";

import { type TransactionReward } from "../types";

type TransactionRewardList = Paginate<TransactionReward<true>>;

export const transactionRewards = createQueryKeys(
  "recognition-transaction-rewards",
  {
    all: (page?: number, filter?: SearchRequest) => [{ page, filter }],
  },
);

const include = "reward,user";

export const fetchTransactionRewardsQueryOptions = (
  page: number = 0,
  search?: SearchRequest,
) =>
  queryOptions({
    ...transactionRewards.all(page, search),
    queryFn: () =>
      api
        .get<TransactionRewardList>(
          `/recognition/transactions/rewards?include=${include}`,
          {
            params: { page, ...search },
          },
        )
        .then((response) => response.data),
  });

export const useFetchTransactionRewards = (search?: SearchRequest) =>
  usePaginateQuery((page) => fetchTransactionRewardsQueryOptions(page, search));

export const useCreateTransactionReward = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (rewardId: number) =>
      api
        .post("/recognition/transactions/rewards/" + rewardId)
        .then((response) => response.data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: transactionRewards.all._def,
      });
    },
  });
};
